'use strict';

var request = require('./request');


function Track ( config ) {
    var prop;

    config = config || {};

    for ( prop in config ) {
        this[prop] = config[prop];
    }
}


Track.prototype = {};
Track.prototype.constructor = Track;


/**
 * gel link to play.
 *
 * @param {Function} callback - result handler
 */
Track.prototype.getUrl = function ( callback ) {
    request(
        'audio-tracks/' + this.id + '/link',
        {
            method: 'GET',
            onload: function ( error, response ) {
                callback(error, error ? null : response.data.url);
            },
            onerror: callback
        }
    );
};


module.exports = Track;
